package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.Image
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.Res
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.brand_mark
import org.jetbrains.compose.resources.painterResource

/**
 * The Mahaleh logo mark — a gold-outlined maple leaf filled with Persian eslimi (arabesque) ornament
 * and the white محله calligraphy (2026-07-18 vector art). Transparent background: place it on
 * [AppTheme.colors.brandInk] (splash/hero tiles) or any dark surface — the leaf body is brand ink, so
 * on the ink tile it reads as the gold outline + florals + white script. Vector masters (`svg/`) +
 * regeneration script live in `branding/`.
 *
 * @param contentDescription localized a11y label, or null when purely decorative next to the app name.
 */
@Composable
fun BrandMark(
    contentDescription: String?,
    modifier: Modifier = Modifier,
) {
    Image(
        painter = painterResource(Res.drawable.brand_mark),
        contentDescription = contentDescription,
        modifier = modifier,
    )
}
